module.exports = __webpack_public_path__ + "img/chinese-DE.bfc430cc.png";